<div class="container">
  <main class="main">
    <div class="header-section">
      <h2 class="page-title">ペルソナ一覧</h2>
      <div class="header-actions">
        <button
          (click)="showCreateForm()"
          class="btn"
          [class.btn-primary]="!isOrderChanged"
          [class.btn-secondary]="isOrderChanged"
        >
          新しいペルソナを作成
        </button>
      </div>
    </div>

    @if (isOrderChanged) {
      <div class="reorder-bar" role="status">
        <p class="reorder-bar-message">
          並び順が変更されています。保存しない場合、他の操作で元に戻ります。
        </p>
        <div class="reorder-bar-actions">
          <button
            (click)="cancelReorder()"
            [disabled]="isSavingOrder"
            class="btn btn-outline"
          >
            キャンセル
          </button>
          <button
            (click)="saveOrder()"
            [disabled]="isSavingOrder"
            class="btn btn-primary"
          >
            {{ isSavingOrder ? '保存中...' : '並び順を保存' }}
          </button>
        </div>
      </div>
    }

    <!-- Delete Confirmation Modal -->
    @if (deleteConfirm.show) {
      <div class="modal-overlay">
        <div class="modal-content">
          <h3 class="modal-title">ペルソナを削除</h3>
          <p class="modal-text">
            「{{
              deleteConfirm.persona?.name
            }}」を削除してもよろしいですか？この操作は取り消せません。
          </p>
          <div class="modal-actions">
            <button (click)="hideDeleteConfirm()" class="btn btn-outline">
              キャンセル
            </button>
            <button
              (click)="handleDeletePersona()"
              [disabled]="isDeleting"
              class="btn btn-danger"
            >
              @if (isDeleting) {
                <span>削除中...</span>
              }
              @if (!isDeleting) {
                <span>削除する</span>
              }
            </button>
          </div>
        </div>
      </div>
    }

    <!-- Form -->
    @if (showForm) {
      <div class="form-container">
        <div class="form-wrapper">
          <h3 class="form-title">
            {{ editingPersona ? 'ペルソナを編集' : '新しいペルソナを作成' }}
          </h3>
          <form [formGroup]="personaForm" (ngSubmit)="onSubmit()">
            <div class="form-grid">
              <div class="form-group">
                <span class="form-label">名前</span>
                <input
                  type="text"
                  formControlName="name"
                  class="form-input"
                  [class.error]="
                    personaForm.get('name')?.invalid &&
                    personaForm.get('name')?.touched
                  "
                />
                @if (
                  personaForm.get('name')?.invalid &&
                  personaForm.get('name')?.touched
                ) {
                  <div class="error-message">名前は必須です</div>
                }
              </div>
              <div class="form-group">
                <span class="form-label">性別</span>
                <select
                  formControlName="gender"
                  class="form-select"
                  [class.error]="
                    personaForm.get('gender')?.invalid &&
                    personaForm.get('gender')?.touched
                  "
                >
                  <option value="">性別を選択してください...</option>
                  <option value="男性">男性</option>
                  <option value="女性">女性</option>
                  <option value="その他">その他</option>
                </select>
                @if (
                  personaForm.get('gender')?.invalid &&
                  personaForm.get('gender')?.touched
                ) {
                  <div class="error-message">性別は必須です</div>
                }
              </div>
              <div class="form-group">
                <span class="form-label">職業</span>
                <input
                  type="text"
                  formControlName="occupation"
                  class="form-input"
                  [class.error]="
                    personaForm.get('occupation')?.invalid &&
                    personaForm.get('occupation')?.touched
                  "
                />
                @if (
                  personaForm.get('occupation')?.invalid &&
                  personaForm.get('occupation')?.touched
                ) {
                  <div class="error-message">職業は必須です</div>
                }
              </div>
              <div class="form-group full-width">
                <span class="form-label">リテラシーレベル</span>
                <select
                  formControlName="literacyLevel"
                  class="form-select"
                  [class.error]="
                    personaForm.get('literacyLevel')?.invalid &&
                    personaForm.get('literacyLevel')?.touched
                  "
                >
                  <option value="">
                    リテラシーレベルを選択してください...
                  </option>
                  <option value="初心者">初心者</option>
                  <option value="中級者">中級者</option>
                  <option value="上級者">上級者</option>
                  <option value="専門家">専門家</option>
                </select>
                @if (
                  personaForm.get('literacyLevel')?.invalid &&
                  personaForm.get('literacyLevel')?.touched
                ) {
                  <div class="error-message">リテラシーレベルは必須です</div>
                }
              </div>
              <div class="form-group full-width">
                <span class="form-label">スキルマップ</span>
                <app-select
                  [id]="'skill-map'"
                  [options]="skillMapOptions"
                  (selectedOptionChange)="changeSkillMap($event)"
                  [selectedOption]="selectedSkillMap"
                ></app-select>
              </div>
              @if (phaseItems.length > 0) {
                <div class="form-group full-width">
                  <span class="form-label">該当フェーズ</span>
                  <app-multiple-select
                    [id]="'applicable-phases'"
                    [items]="phaseItems"
                    (changeSelected)="changeSelectedPhases($event)"
                  ></app-multiple-select>
                </div>
              }
              <div class="form-group full-width">
                <span class="form-label">場面 (任意)</span>
                <textarea
                  formControlName="scene"
                  class="form-textarea"
                  rows="2"
                  placeholder="ロールプレイの場面設定..."
                ></textarea>
              </div>
              <div class="form-group full-width">
                <span class="form-label">目的 (任意)</span>
                <textarea
                  formControlName="purpose"
                  class="form-textarea"
                  rows="2"
                  placeholder="ロールプレイの目的..."
                ></textarea>
              </div>
              <div class="form-group">
                <span class="form-label">目安所要時間（分） (任意)</span>
                <input
                  type="number"
                  formControlName="estimatedMinutes"
                  class="form-input"
                  step="1"
                  [class.error]="
                    personaForm.get('estimatedMinutes')?.invalid &&
                    personaForm.get('estimatedMinutes')?.touched
                  "
                />
                @if (
                  personaForm.get('estimatedMinutes')?.invalid &&
                  personaForm.get('estimatedMinutes')?.touched
                ) {
                  <div class="error-message">
                    目安所要時間は整数で入力してください
                  </div>
                }
              </div>
              <!-- Scenarios Section -->
              <div class="form-group full-width scenarios-section">
                <div class="scenarios-header">
                  <span class="form-label">シナリオ設定</span>
                  <button
                    type="button"
                    (click)="addScenario()"
                    class="btn btn-sm btn-outline"
                  >
                    + シナリオを追加
                  </button>
                </div>
                <div formArrayName="scenarios" class="scenarios-list">
                  @for (
                    scenario of scenarios.controls;
                    track scenario;
                    let i = $index
                  ) {
                    <div [formGroupName]="i" class="scenario-item">
                      <div class="scenario-header">
                        <h4 class="scenario-title">シナリオ {{ i + 1 }}</h4>
                        <button
                          type="button"
                          (click)="removeScenario(i)"
                          class="btn btn-sm btn-danger"
                        >
                          削除
                        </button>
                      </div>
                      <div class="scenario-fields">
                        <div class="form-group">
                          <span class="form-label">シナリオ名</span>
                          <input
                            type="text"
                            formControlName="name"
                            class="form-input"
                            placeholder="例：初回ヒアリング"
                          />
                        </div>
                        <div class="form-group">
                          <span class="form-label">重み (1以上の整数)</span>
                          <input
                            type="number"
                            formControlName="weight"
                            class="form-input"
                            min="1"
                          />
                        </div>
                        <div class="form-group full-width">
                          <span class="form-label">シナリオ内容</span>
                          <textarea
                            formControlName="scenarioSetting"
                            class="form-textarea"
                            rows="6"
                            placeholder="シナリオ設定を記述してください。&#10;例：&#10;1回目: 予算と導入時期について確認&#10;2回目: 他社比較と課題のヒアリング"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  }
                  @if (scenarios.length === 0) {
                    <div class="empty-scenarios">
                      <p>
                        シナリオが追加されていません。「+
                        シナリオを追加」ボタンをクリックして追加してください。
                      </p>
                    </div>
                    <div class="error-message">
                      シナリオを1件以上追加してください
                    </div>
                  }
                </div>
              </div>
              <div class="form-actions">
                <button
                  type="submit"
                  [disabled]="personaForm.invalid || isSubmitting"
                  class="btn btn-primary"
                >
                  @if (isSubmitting) {
                    <span>処理中...</span>
                  }
                  @if (!isSubmitting) {
                    <span>{{
                      editingPersona ? 'ペルソナを更新' : 'ペルソナを作成'
                    }}</span>
                  }
                </button>
                <button
                  type="button"
                  (click)="hideForm()"
                  class="btn btn-outline"
                >
                  キャンセル
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    }

    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
        <p class="loading-text">読み込み中...</p>
      </div>
    }

    <!-- Persona List -->
    @if (!isLoading) {
      <div class="persona-list">
        @if (personas.length > 0) {
          <div
            class="persona-cards-container"
            cdkDropList
            [cdkDropListDisabled]="isSavingOrder"
            (cdkDropListDropped)="onDrop($event)"
          >
            @for (persona of personas; track persona.id) {
              <div class="persona-card" cdkDrag>
                <div class="persona-header">
                  <div class="persona-title">
                    <span
                      class="drag-handle"
                      cdkDragHandle
                      [attr.aria-label]="
                        persona.name + 'をドラッグして並べ替え'
                      "
                    >
                      <mat-icon aria-hidden="true">drag_indicator</mat-icon>
                    </span>
                    <h3 class="persona-name">{{ persona.name }}</h3>
                  </div>
                  <div class="persona-actions">
                    <button
                      (click)="duplicatePersona(persona)"
                      class="btn btn-outline btn-sm"
                    >
                      複製
                    </button>
                    <button
                      (click)="editPersona(persona)"
                      class="btn btn-secondary btn-sm"
                    >
                      編集
                    </button>
                    <button
                      (click)="showDeleteConfirm(persona)"
                      class="btn btn-danger btn-sm"
                    >
                      削除
                    </button>
                  </div>
                </div>
                <div class="persona-details">
                  <div class="detail-item">
                    <span class="detail-label">性別:</span>
                    {{ persona.gender }}
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">職業:</span>
                    {{ persona.occupation }}
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">リテラシー:</span>
                    {{ persona.literacyLevel }}
                  </div>
                </div>
                <div class="persona-descriptions">
                  <div class="description-item">
                    <div class="description-label">
                      シナリオ ({{ persona.scenarios.length }}件):
                    </div>
                    <div class="scenarios-summary">
                      @for (scenario of persona.scenarios; track scenario) {
                        <div class="scenario-summary-item">
                          <strong>{{ scenario.name }}</strong> (重み:
                          {{ scenario.weight }})
                        </div>
                      }
                      @if (persona.scenarios.length === 0) {
                        <div class="no-scenarios">
                          シナリオが設定されていません
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="empty-state">
            <div class="empty-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
            </div>
            <h3 class="empty-title">ペルソナがありません</h3>
            <p class="empty-description">
              最初のペルソナを作成して顧客設定を始めましょう
            </p>
            <button (click)="showCreateForm()" class="btn btn-primary">
              最初のペルソナを作成
            </button>
          </div>
        }
        <!-- No Personas State -->
      </div>
    }
  </main>
</div>
